import { Box, Button, Collapse, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronRight } from '@tabler/icons-react';
import { useState } from 'react';
import { PlanStatusBadge } from '../StatusBadge/StatusBadge.js';
import { PushOps } from './PushOps.js';
import { resultSentence, resultTitle, type PushEnvironmentResult } from './pushSummary.js';

/** The result in place, per environment, the operations expandable — a toast is the wrong place for the one irreversible thing this tool does. */
export const PushResult = ({ result, onClose }: { result: PushEnvironmentResult[]; onClose: () => void }) => {
    const [open, setOpen] = useState<string | null>(null);
    return (
        <Stack gap={0}>
            <Group px="lg" py="md" style={{ borderBottom: '1px solid var(--rgs-line)' }} justify="space-between">
                <Text fz="h2" ff="heading">
                    {resultTitle(result)}
                </Text>
                <Button variant="default" size="compact-sm" onClick={onClose}>
                    Close
                </Button>
            </Group>
            <Stack gap="sm" p="lg">
                {result.map((r) => (
                    <Box key={r.name}>
                        <UnstyledButton
                            onClick={() => setOpen(open === r.name ? null : r.name)}
                            style={{ width: '100%' }}
                            disabled={r.ops.length === 0}
                        >
                            <Group justify="space-between" wrap="nowrap">
                                <Group gap="xs" wrap="nowrap">
                                    {r.ops.length > 0 &&
                                        (open === r.name ? (
                                            <IconChevronDown size={14} stroke={1.7} />
                                        ) : (
                                            <IconChevronRight size={14} stroke={1.7} />
                                        ))}
                                    <Text className="rgs-numeric" fw={600}>
                                        {r.name}
                                    </Text>
                                    {r.status === 'refused' ? (
                                        <Text fz="xs" c="red">
                                            refused
                                        </Text>
                                    ) : (
                                        <PlanStatusBadge status={r.status} size="xs" />
                                    )}
                                </Group>
                                <Text fz="xs" c="dimmed">
                                    {resultSentence(r)}
                                </Text>
                            </Group>
                        </UnstyledButton>
                        <Collapse in={open === r.name}>{open === r.name && <PushOps ops={r.ops} />}</Collapse>
                    </Box>
                ))}
            </Stack>
        </Stack>
    );
};
